import React, { useState } from "react";
import "./MagicAssignment.css"; // Import CSS for styling

const MagicAssignment = () => {
    const [formData, setFormData] = useState({
        name: "",
        address: "",
        day: "",
        month: "",
        year: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
    };

    return (
        <form className="magic-assignment-form" onSubmit={handleSubmit}>
            <div className="form-header">Fillable Fields</div>
            <table className="form-table">
                <tbody>
                    <tr>
                        <td className="label">Name</td>
                        <td>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="input-field"
                            />
                        </td>
                        <td className="label">Date</td>
                        <td>
                            <input
                                type="text"
                                name="day"
                                value={formData.day}
                                onChange={handleChange}
                                className="input-field date-field"
                                placeholder="Day"
                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                name="month"
                                value={formData.month}
                                onChange={handleChange}
                                className="input-field date-field"
                                placeholder="Month"
                            />
                        </td>
                        <td>
                            <input
                                type="text"
                                name="year"
                                value={formData.year}
                                onChange={handleChange}
                                className="input-field date-field"
                                placeholder="Year"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="label">Address</td>
                        <td colSpan="5">
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="input-field full-width"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <button type="submit" className="submit-button">
                Submit
            </button>
        </form>
    );
};

export default MagicAssignment;

